import { ApproveCommissionPayment } from '../../pages/';
import { EmployeeController } from '../../controllers';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import { MimaToastUtil } from '../../components';

const ApproveCommissionPaymentContainer = ({ closeModal, goBack }) => {
	const [loading, setLoading] = useState(false);
	const validationSchema = () => {
		return yup.object({
			tag: yup.string().required('Tag is required'),
			action: yup.string().required('Action is required'),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);

		const { status, errorMessage } = await EmployeeController.actionCommissionBulkPayment(
			payload
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<ApproveCommissionPayment
			closeModal={closeModal}
			loading={loading}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			goBack={goBack}
		/>
	);
};

export default observer(ApproveCommissionPaymentContainer);
